import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { select, Store } from "@ngrx/store";
import { AppError, JurisdictionSelector, MessageScopeType, MessageService, MessageType } from "@obg/ngx.core";
import { DeviceConfigService, ignoreNil } from "@obg/ngx.global";
import { merge, of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { CoreContentState } from "../state";

import { IconAction } from "./icon.action";
import { IconService } from "./icon.service";

/**
 * @deprecated [fabric-deprecated] - Use "document.obgEventBus.retrieve(ContentValue.getIcons_v2)" instead
 */
@Injectable()
export class IconEffect {
	/**
	 * @deprecated [fabric-deprecated] - Use "document.obgEventBus.retrieve(ContentValue.getIcons_v2)" instead
	 */
	getAll$ = createEffect(() =>
		this.actions$.pipe(
			ofType(IconAction.getAll),
			switchMap(() =>
				this.store.pipe(
					select(JurisdictionSelector.get),
					ignoreNil(),
					switchMap((jurisdiction) =>
						this.service.getAll(this.deviceConfigService.getType(), jurisdiction).pipe(
							map((icons) => IconAction.getAllSuccess(icons)),
							catchError((error: AppError) => of(IconAction.getAllFail(error)))
						)
					)
				)
			)
		)
	);

	initMessages$ = createEffect(() =>
		merge(
			this.messageService.mapErrorByContext$(
				{
					[IconAction.getAllFail.type]: IconAction.getAll.type,
				},
				MessageScopeType.Global,
				MessageType.Error
			),
			this.messageService.mapClearByContext$({
				[IconAction.getAll.type]: IconAction.getAll.type,
			})
		)
	);

	constructor(
		private actions$: Actions,
		private service: IconService,
		private messageService: MessageService,
		private store: Store<CoreContentState>,
		private deviceConfigService: DeviceConfigService
	) {}
}
